import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openAccessDescription: {
		id: 'servicedesk-customer-permissions.common.customer-access-status.open-access-description',
		defaultMessage: 'Anyone can submit requests to this project.',
		description: 'Description of open customer access, i.e. all customers can access portal',
	},
	restrictedAccessDescription: {
		id: 'servicedesk-customer-permissions.common.customer-access-status.restricted-access-description',
		defaultMessage: 'Only people directly invited to this project can submit requests.',
		description:
			'Description of restricted customer access, i.e. only some customers can access portal',
	},
	editCustomerPermissions: {
		id: 'servicedesk-customer-permissions.common.customer-access-status.edit-customer-permissions',
		defaultMessage: 'Edit customer permissions',
		description: 'Takes user from customer portal page to customer permissions page (channels)',
	},
});
